import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, Upload } from 'antd';
import Swal from 'sweetalert2';
import { InboxOutlined } from '@ant-design/icons';
import productsService from '../../../../services/Products';
import '../../sales/components/uploadModal.css'

const { Dragger } = Upload;

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            : 'white'
  }
};

const UploadExcelModal = ( { campaign, handlerClose, refreshAction } ) => {

  const [ loading, setLoading ] = useState( false )
  const [ downloadingTemplate, setDownloadingTemplate ] = useState( false )
  const [ file, setFile ] = useState( null )

  const draggerProps = {
    name: 'file',
    accept: '.xls, .xlsx',
    multiple: false,
    showUploadList: false,
    beforeUpload: () => false,
    onChange: ( info ) => {
      setFile( info.file )
    }
  };

  const uploadFiles = () => {

    if ( !file ){
      Swal.fire({
        icon: 'warning',
        title: 'Archivo sin seleccionar',
        text: 'Por favor seleccione el archivo para continuar'
      })

      return;
    }

    if ( !campaign ){
      Swal.fire({
        icon: 'warning',
        title: 'Campaña inválida',
        text: 'No encontramos la campaña seleccionada para procesar la importación.'
      })

      return;
    }

    setLoading( true )

    Swal.fire ({
      title: '..Subiendo excel..',
      onBeforeOpen: () => {
        Swal.showLoading ()
      }
    })

    productsService.uploadExcel( { file, year: campaign } )
      .then( ( res ) => {

        const responseData = res.data || {}
        const details = responseData.details || {}
        const errors = responseData.errors || []

        if ( responseData.success ) {
          const resumeText = [
            `Líneas creadas: ${ details.lines_created || 0 }`,
            `Grupos creados: ${ details.groups_created || 0 }`,
            `Productos creados: ${ details.products_created || 0 }`,
            `Errores: ${ details.total_errors || 0 }`
          ].join( '\n' )

          Swal.fire({
            icon: errors.length ? 'warning' : 'success',
            title: errors.length ? 'Importación finalizada con observaciones' : 'Importación exitosa',
            text: resumeText
          })

          refreshAction();
          handlerClose();

          return;
        }

        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          text: responseData.message || 'No pudimos procesar el excel de productos.'
        })
      } )
      .catch( ( err ) => {

        console.log( err )
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          text: err.code || 'No pudimos subir el excel, contactese con un administrador.'
        })

      } )
      .finally( () => {
        setLoading( false )
      } )

  }

  const downloadTemplate = () => {

    setDownloadingTemplate( true )

    productsService.downloadExcelTemplate()
      .then( ( res ) => {
        const url = window.URL.createObjectURL( new Blob( [ res.data ] ) )
        const link = document.createElement( 'a' )
        link.href = url
        link.setAttribute( 'download', 'template-productos.xlsx' )
        document.body.appendChild( link )
        link.click()
        link.remove()
        window.URL.revokeObjectURL( url )
      } )
      .catch( () => {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrio un error',
          text: 'No pudimos descargar el template de productos. Intenta nuevamente.'
        })
      } )
      .finally( () => {
        setDownloadingTemplate( false )
      } )
  }

  return (
    <div>
      <Modal
              isOpen={ true }
              onRequestClose={ handlerClose }
              style={ customStyles }
            >

        <div className="modalContainer upload">
            <div className='title'> Subir excel de productos </div>
            <Dragger {...draggerProps} file={ file }>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Clickea aquí o arrastrá tu excel con productos</p>
            </Dragger>

            <div className='actions'>
              <Button onClick={ downloadTemplate } disabled={ loading || downloadingTemplate } loading={ downloadingTemplate }> Descargar template </Button>
              <Button onClick={ uploadFiles } disabled={ loading || downloadingTemplate || !file || !campaign } loading={ loading }> Subir </Button>
            </div>
        </div>

      </Modal>
    </div>
  )
}

export default UploadExcelModal
